export const TerminalMenuItems = [
  { label: 'Account', url: 'account' },
  { label: 'Readers', url: 'readers' },
  { label: 'Settings', url: 'settings' },
];

export enum TerminalMenuLabels {
  Account = 'Account',
  Readers = 'Readers',
  Settings = 'Settings',
}

export interface TerminalSettings {
  convenienceFee: boolean;
  stripeLocationId: string;
  platformFeePercentage: number;
}

export const DEFAULT_TERMINAL_SETTINGS: TerminalSettings = {
  convenienceFee: true,
  stripeLocationId: '',
  platformFeePercentage: 0,
};

export interface ConnectAccountDetails {
  accountId: string;
  businessName: string | null;
  email: string | null;
  country: string | null;
  chargesEnabled: boolean;
  payoutsEnabled: boolean;
  detailsSubmitted: boolean;
  requirementsCurrentlyDue: number;
  requirementsPastDue: number;
  disabledReason: string | null;
  createdAt: string | null;
}

export interface TerminalReader {
  id: string;
  label?: string;
  device_type?: string;
  serial_number?: string;
  status?: string;
}
